export enum BackgroundColor {
  White,
  WhiteDove,
}

export enum Padding {
  Normal = 'normal',
}
